import { i18n } from '@fides/fides-react-components';

import translationEN from './translations/en/main.json';
import translationDE from './translations/de/main.json';
import translationES from './translations/es/main.json';
import translationFR from './translations/fr/main.json';
import translationIT from './translations/it/main.json';
import { JsonObject } from '../types';

const resources: JsonObject = {
  en: translationEN,
  de: translationDE,
  es: translationES,
  fr: translationFR,
  it: translationIT,
};

i18n.setDefaultNamespace('mbs');

Object.keys(resources).forEach((lang: string) => {
  i18n.addResourceBundle(lang, 'mbs', resources[lang]);
});

export default i18n;
